import React, { useEffect } from "react";
import Marketcap from "./marketcap";
import {
  Box,
  Grid,
  List,
  ListItem,
  Paper,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import Trending from "./trending";
import Gainers from "./gainers";
import TrendingIcon from "src/images/TrendingIcon.png";
import Topgainers from "src/images/market-segment.png";
import "./style.css";
import axiosInstance from "src/utils/axios";
import { keyframes } from "@mui/system";

import {
  MonetizationOn,
  Store,
  BarChart,
  ShowChart,
  FlashOn,
  Opacity,
} from "@mui/icons-material";
import Coin from "./coin";
const Item = ({ children }) => {
  return (
    <Paper elevation={1} style={{ boxShadow: "none" }}>
      {children}
    </Paper>
  );
};
const marquee = keyframes`
  0% { transform: translateX(100%); }
  100% { transform: translateX(-50%); }
`;

const Crtpto = () => {
  const [marketCap, setMarketCap] = React.useState({});
  const [global, setGlobal] = React.useState({});
  const theme = useTheme();
  // const fetchData = async () => {
  //   try {
  //     const { data } = await axiosInstance.get("api/market-cap");
  //     if (data.status) {
  //       setMarketCap(data?.data);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // useEffect(() => {
  //   fetchData();
  // }, []);

  const fetchGlobalData = async () => {
    try {
      const { data } = await axiosInstance.get("api/crypto-data");
      if (data.status) {
        setGlobal(data?.data);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchGlobalData();
  }, []);

  return (
    <div>
      <Box
        sx={{
          background: "linear-gradient(to right, #0b1d3b, #243b55)",
          p: 1,
          display: "flex",
          justifyContent: "center",
          overflow: "hidden",
          position: "relative",
          // borderRadius: 2,
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
        }}
      >
        <Box
          sx={{
            width: "100%",
            whiteSpace: "nowrap",
          }}
        >
          <List
            className="coinDetails"
            sx={{
              display: "inline-flex",
              gap: 4,
              animation: `${marquee} 25s linear infinite`,
              alignItems: "center",
            }}
          >
            {[
              {
                icon: <Store fontSize="small" sx={{ color: "#00bcd4" }} />,
                label: "Exchanges",
                value: global?.exchanges,
              },
              {
                icon: (
                  <MonetizationOn fontSize="small" sx={{ color: "#ffc107" }} />
                ),
                label: "Market Cap",
                value: global?.market_cap,
              },
              {
                icon: <BarChart fontSize="small" sx={{ color: "#4caf50" }} />,
                label: "24h Vol",
                value: global?.volume_24h,
              },
              {
                icon: <ShowChart fontSize="small" sx={{ color: "#2196f3" }} />,
                label: "Dominance",
                value: `BTC ${global?.btc_dominance}`,
              },
              {
                icon: <ShowChart fontSize="small" sx={{ color: "#9c27b0" }} />,
                label: "ETH Dominance",
                value: `ETH ${global?.eth_dominance}`,
              },
              {
                icon: <FlashOn fontSize="small" sx={{ color: "#f44336" }} />,
                label: "Gas",
                value: global?.eth_gas,
              },
            ].map((item, index) => (
              <Tooltip title={item.label} key={index}>
                <ListItem
                  sx={{
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    borderRadius: 2,
                    backdropFilter: "blur(4px)",
                  }}
                >
                  {item.icon}
                  <Typography color="white" fontWeight="bold" variant="body1">
                    {item.label}:
                  </Typography>
                  <Typography color="white" variant="body1">
                    {item.value}
                  </Typography>
                </ListItem>
              </Tooltip>
            ))}
          </List>
        </Box>
      </Box>
      {/* <div id="about" class="container">
        <Box sx={{ flexGrow: 1, p: 5 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={4}>
              <Marketcap marketCap={marketCap} />
            </Grid>

            <Grid item xs={12} sm={6} lg={4}>
              <Item>
                <Box
                  className="bglight1"
                  sx={{
                    px: 2.5,
                    py: 3,
                    borderRadius: "8px",
                    backgroundColor: "#264b83",
                  }}
                >
                  <Box className="flex items-center gap-5" sx={{ mb: 1.5 }}>
                    <Typography color={"white"} className="trendingCaption">
                      Trending
                    </Typography>
                    <img
                      src={TrendingIcon}
                      style={{ height: "20px", width: "20px" }}
                      alt="Trending Icon"
                    />
                  </Box>
                  <Trending />
                </Box>
              </Item>
            </Grid>

            <Grid item xs={12} sm={6} lg={4}>
              <Item>
                <Box
                  className="bglight1"
                  sx={{
                    px: 2.5,
                    py: 3,
                    borderRadius: "8px",

                    backgroundColor: "#264b83",
                  }}
                >
                  <Box className="flex items-center gap-5">
                    <Typography className="trendingCaption" color={"white"}>
                      Top Categories
                    </Typography>
                    <img
                      src={Topgainers}
                      style={{ height: "20px", width: "20px" }}
                      alt="Trending Icon"
                    />
                  </Box>
                  <Gainers />
                </Box>
              </Item>
            </Grid>
          </Grid>
          <Coin market={global?.market_cap} />
        </Box>
      </div> */}
    </div>
  );
};

export default Crtpto;
